// extracted by mini-css-extract-plugin
export default {"facetSearchContainer":"facetSearchContainer---KDy4w","facetSearch":"facetSearch---UIC4G","moreIcon":"moreIcon---G7rRx"};